module.exports = __webpack_public_path__ + "static/media/phrase-waiting.c90b387f.svg";